export function safeReturnPath(value: unknown, fallback = '/user/dashboard'): string {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') &&
    !Array.from(value).some(character => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 92)
    ? value : fallback;
}
